import { render } from "./PlaceholdersContent.vue?vue&type=template&id=79c44d96"
import script from "./PlaceholdersContent.vue?vue&type=script&lang=js"
export * from "./PlaceholdersContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__